import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { PROFILE_FEATURE_KEY } from './keys';
import { profileReducer } from './reducers/profile.reducer';
import { ProfileEffects } from './effects/profile.effects';

export function provideProfileStore(): EnvironmentProviders[] {
    return [provideState(PROFILE_FEATURE_KEY, profileReducer), provideEffects(ProfileEffects)];
}
